import { createContext, useContext } from 'react'
import type { FeedbackContext } from '@metro/feedback'

export interface FeedbackContextValue {
  openFeedback: (context: FeedbackContext) => void
}

export const FeedbackControllerContext = createContext<FeedbackContextValue | null>(null)

/**
 * Opens the Feedback form for a context. Returns a no-op opener when used
 * outside the provider (defensive — keeps non-app render paths safe).
 *
 * Sits beside its context rather than inside the provider component so
 * neither forces a Fast Refresh remount of the other (TASK-570).
 */
export function useFeedback(): FeedbackContextValue {
  const ctx = useContext(FeedbackControllerContext)
  return ctx ?? { openFeedback: () => {} }
}
